import React from "react";
import SponsorCodeContext from "./SponsorCodeContext";

export default function useSponsorCode() {
  return React.useContext(SponsorCodeContext);
}
